/** @format */

function getEmail(id) {
  return this.getField(id, "email");
}

export { getEmail };
